import React from "react";
import { Phone, MapPin, Clock, Star } from "lucide-react";

export default function Contact() {
  const mapUrl = "https://www.google.com/maps?q=CHAND+BOOK+DEPOT+Kanjhawala+Rd+Avantika+Rohini+Delhi+110085&output=embed";

  return (
    <div data-testid="contact-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
      <div className="grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-5">
          <div className="text-xs uppercase tracking-[0.22em] text-neutral-500 mb-3">Say Hello</div>
          <h1 className="font-serif text-5xl lg:text-6xl text-[#0F172A] tracking-tight leading-[0.95]">
            Come <span className="italic text-[#E05A47]">visit us</span>
          </h1>
          <p className="mt-5 text-neutral-600 text-[15px] leading-relaxed max-w-md">
            Chand Book Depot is a short walk from Rohini Sector 1. Call before visiting or drop by during opening hours.
          </p>

          <div className="mt-10 space-y-5">
            <InfoRow icon={<MapPin size={18}/>} label="Address">
              Sector-1, B-779, Kanjhawala Rd,<br/>Avantika, Rohini, Delhi, 110085
            </InfoRow>
            <InfoRow icon={<Phone size={18}/>} label="Phone">
              <a href="tel:09211813521" data-testid="contact-call-link" className="hover:text-[#E05A47]">092118 13521</a>
            </InfoRow>
            <InfoRow icon={<Clock size={18}/>} label="Hours">
              Closed · Opens 9 am Tue
            </InfoRow>
            <InfoRow icon={<Star size={18}/>} label="Rating">
              3.8 · 747 Reviews on Google
            </InfoRow>
          </div>

          <a
            href="tel:09211813521"
            data-testid="contact-primary-call"
            className="mt-10 inline-flex items-center gap-2 bg-[#0F172A] text-white px-6 py-3 rounded-full text-sm hover:bg-[#E05A47] transition-colors"
            style={{ transitionProperty: "background-color" }}
          >
            <Phone size={14}/> Call the shop
          </a>
        </div>

        <div className="col-span-12 md:col-span-7">
          <div className="rounded-2xl overflow-hidden border border-neutral-200 h-[520px] bg-white">
            <iframe
              title="Chand Book Depot Location"
              src={mapUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="google-map-iframe"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function InfoRow({ icon, label, children }) {
  return (
    <div className="flex items-start gap-4">
      <div className="w-10 h-10 rounded-lg bg-[#F1EDE7] text-[#4A6741] flex items-center justify-center shrink-0">
        {icon}
      </div>
      <div>
        <div className="text-[11px] uppercase tracking-[0.22em] text-neutral-500">{label}</div>
        <div className="text-neutral-800 mt-1 leading-relaxed">{children}</div>
      </div>
    </div>
  );
}
